const ICONS = "/iceholidays-assets/images/icons";

export interface TierOption {
  value: string;
  tier: string;
  name: string;
  icon: string;
  color: string;
}

export const TIER_OPTIONS: TierOption[] = [
  { value: "gt_5a_plus", tier: "5A+", name: "Ultimate Collection", icon: `${ICONS}/icon-tier-5a-plus.png`, color: "#942E91" },
  { value: "gt_5a", tier: "5A", name: "Luxury Leisure", icon: `${ICONS}/icon-tier-5a.png`, color: "#D09A12" },
  { value: "gt_4a", tier: "4A", name: "Upscale Experience", icon: `${ICONS}/icon-tier-4a.png`, color: "#288796" },
  { value: "gt_3a", tier: "3A", name: "Essential Comfort", icon: `${ICONS}/icon-tier-3a.png`, color: "#373C48" },
];

export const tierOption = (value?: string): TierOption | undefined =>
  value ? TIER_OPTIONS.find((option) => option.value === value) : undefined;

export const tierLabel = (value: string): string => tierOption(value)?.tier || value;
